import { useScaffold } from "@Light/scaffold";
import { Button } from "@Light/components/page/Button";
import clsx from "clsx";
import { ArrowRightIcon } from "@heroicons/react/24/outline";
import { useInvoice } from "./context";
import { createInvoiceLink, useInvoiceLink } from "./common";
import { usePlan } from "@Light/utils/plan";

export type MakePaymentLinkProps = {};

export const MakePaymentLink: React.FC<MakePaymentLinkProps> = ({}) => {
  const { invoice } = useInvoice();
  const { plan } = usePlan();
  const invoiceLink = useInvoiceLink(invoice);
  const scaffold = useScaffold();
  const Link = scaffold.system.link;
  if (invoice.paid_at || !plan) {
    return null;
  }
  if (invoice.rebill_invoice) {
    return (
      <div className="flex flex-col gap-4">
        <div className={clsx(scaffold.page.colors.text.tertiary, "text-sm")}>
          We received a revised meter reading for your account from your
          utility, {plan.tdu_name}.
        </div>
        <Link to={createInvoiceLink(invoice.rebill_invoice)} className="w-full">
          <Button className="w-full">View correction invoice</Button>
        </Link>
      </div>
    );
  }
  if (invoice.is_deferred && invoice.total_cents < 50) {
    return (
      <div className={clsx(scaffold.page.colors.text.tertiary, "text-sm")}>
        Invoices below $0.50 are deferred and paid in future invoices.
      </div>
    );
  }
  if (invoice.is_deferred) {
    return (
      <div className={clsx(scaffold.page.colors.text.tertiary, "text-sm")}>
        You requested to defer this invoice to future invoices.
      </div>
    );
  }
  return (
    <Link to={`${invoiceLink}make-payment`}>
      <div
        className={clsx("flex flex-row items-center gap-1 font-medium text-sm")}
      >
        <div>Make payment</div>
        <ArrowRightIcon className="w-4 h-4" />
      </div>
    </Link>
  );
};
